export default {
    // service_ip: 'http://192.168.0.233:8080',
    // login_ip: 'http://localhost:9000/#/login'
    // 发布 该ip为服务器对外的ip
    service_ip: '/ldspj',
    login_ip: 'http://47.106.190.90:8200/ldspj/#/login'

    // 以下ip为开发环境
    //service_ip: 'http://192.168.110.145:8080/ldspj',
    //login_ip: 'http://192.168.110.145:8200/ldspj/#/login'

    // service_ip: 'http://192.168.31.92:8080/ldspj',
    // login_ip: 'http://192.168.31.92:8300/ldspj/#/login'
    // service_ip: 'http://localhost:8080/ldspj',
    // login_ip: 'http://localhost:8300/ldspj/#/login'
    // 以下ip为生产环境
    // service_ip: 'http://192.168.0.114:8083/ldspj',
    // login_ip: 'http://192.168.0.114:8300/ldspj/#/login'
    // service_ip: 'http://116.25.236.85:8083/ldspj',
    // login_ip: 'http://116.25.236.85:8300/ldspj/#/login'
    // 以下ip为准生产环境
    // service_ip: 'http://192.168.0.112:8081/ldspj',
    // login_ip: 'http://192.168.0.112:9500/ldspj/#/login'
};



// WEBPACK FOOTER //
// ./src/common/js/config.js